import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  emptySectionPassRebate,
  type FirestoreUserProfileSectionPassRebate,
} from '../firestore/UserProfileSectionPass/schema'

export class UserProfileSectionPassRebate extends ObservableModelWithDecorators<FirestoreUserProfileSectionPassRebate> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, emptySectionPassRebate)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, emptySectionPassRebate)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreUserProfileSectionPassRebate>
  ) {
    super(repository, doc)
  }

  get exists() {
    return !this.hasData && this.isLoaded && this.isNotEmpty
  }
}
